import { useRef } from 'react';
import { IService } from '../../rz-status_models';
import Incident from './Incident';
import Status from './StateIconFromObject';

export default function({service, hideState = false}:{service: IService, hideState: boolean})  {
  const dialogRef = useRef<HTMLDialogElement>(null)

  function open() {
    document.body.style.overflow = "hidden";
    dialogRef.current.showModal()
  }
  function close() {
    document.body.style.overflow = "";
    dialogRef.current.close()
  }

  if(service.incident == null) {
    return <li className="service">{!hideState && <Status item={service}/>} <span className="overflow">{service.name}</span></li>
  }
  else {
    return <>
      <button className="service hasIncident" aria-label={`Details zum Vorfall zu "${service.name}" öffnen`} aria-controls={service.id} onClick={open}>{!hideState && <Status item={service}/>} <span className="overflow">{service.name}</span></button>
      <dialog id={service.id} ref={dialogRef} className="modal" onClick={(e) => { if (e.target == dialogRef.current) {
          close();
        }}}>
        <div onClick={() => {}}>
          <button className="modal-close" onClick={close} aria-label="Vorfall-Details schließen"><span className="icon close"></span></button>
          <Incident incident={service.incident} detail />
        </div>
      </dialog> 
    </>
  }
}